import React, { useEffect, useState } from 'react';
import Toggle from 'react-toggle';
import {
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import "react-toggle/style.css"; // Import toggle styles
import 'bootstrap/dist/css/bootstrap.min.css';
import { Fn_FillListData, Fn_DisplayData, showToastWithCloseButton, Fn_AddEditData } from 'store/Functions';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { API_WEB_URLS } from 'constants/constAPI';

const AddEdit_PlanAdd = () => {
  const API_URL = `${API_WEB_URLS.MASTER}/0/token/Plans`;
  const API_URL1 = `${API_WEB_URLS.MASTER}/0/token/Product`;
  const API_URL_SAVE = 'Masters/0/token/PlanMaster';
    const API_URL_SAVE1 = "PlanMasterL/0/token"
  const API_URL_EDIT = `${API_WEB_URLS.MASTER}/0/token/ProductRateEdit/Id`;

  const [state, setState] = useState({
    id: 0,
    FillArray: [],
    FillArray1: [],
    formData: {
      F_PlanMaster: '',
      F_ProductMaster: '',
      RangeFrom: '',
      RangeTo: '',
      Amount: '',
      IsFlat: false,
    },
    isProgress: true,
  });

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newPlanName, setNewPlanName] = useState('');

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate()
  useEffect(() => {
    Fn_FillListData(dispatch, setState, 'FillArray', `${API_URL}/Id/0`);
    Fn_FillListData(dispatch, setState, 'FillArray1', `${API_URL1}/Id/0`);

    const Id = (location.state && location.state.Id) || 0;
    if (Id > 0) {
      setState((prevState) => ({ ...prevState, Id }));
      Fn_DisplayData(dispatch, setState, Id, API_URL_EDIT);
    }
  }, [dispatch, location.state]);

  const handleInputChange = (field, value) => {
    setState((prevState) => ({
      ...prevState,
      formData: {
        ...prevState.formData,
        [field]: value,
      },
    }));
  };

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  const handleModalSubmit = async () => {
    if (newPlanName.trim()) {
      try {
        const response = await fetch(API_WEB_URLS.BASE + API_URL_SAVE, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ name: newPlanName }),
        });

        const data = await response.json();
        const resId = data?.data?.data?.Id;
        if (resId && resId > 0) {
          showToastWithCloseButton('success', 'Plan saved');
        }

        if (response.ok) {
          console.log('New Plan Name successfully added:', newPlanName);
          setNewPlanName('');
          toggleModal();
        } else {
          console.error('Failed RangeTo add new plan:', data);
        }
      } catch (error) {
        console.error('Error adding new plan:', error);
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const obj = JSON.parse(localStorage.getItem("authUser"))
  
    let formData = new FormData()
    formData.append("F_ProductMaster", state.formData.F_ProductMaster)
    formData.append("F_PlanMaster", state.formData.F_PlanMaster)
    formData.append("IsFlat", state.formData.IsFlat)
    formData.append("RangeFrom", state.formData.RangeFrom)
    formData.append("RangeTo", state.formData.RangeTo)
    formData.append("Amount", state.formData.Amount)
    formData.append("UserId", obj.uid)

    Fn_AddEditData(
      dispatch,
      setState,
      { arguList: { id: state.id, formData } },
      API_URL_SAVE1,
      true,
      "memberid",
      navigate,
    "/ProductRateMaster"
    );
  };

  return (
    <div className="page-content">
      <Card>
        <CardBody>
          <CardTitle tag="h3" className="text-center mb-4">
            Add/Edit Plan
          </CardTitle>
          <Form onSubmit={handleSubmit}>
            <Row form>
              <Col md={6}>
                <FormGroup>
                  <Label for="F_PlanMaster">Plan</Label>
                  <Input
                    type="select"
                    id="F_PlanMaster"
                    value={state.formData.F_PlanMaster}
                    onChange={(e) => handleInputChange('F_PlanMaster', e.target.value)}
                  >
                    <option value="">Select</option>
                    {state.FillArray.map((plan) => (
                      <option key={plan.Id} value={plan.Id}>
                        {plan.Name}
                      </option>
                    ))}
                  </Input>
                  <Button color="link" onClick={toggleModal}>
                    Add
                  </Button>
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup>
                  <Label for="F_ProductMaster">Product</Label>
                  <Input
                    type="select"
                    id="F_ProductMaster"
                    value={state.formData.F_ProductMaster}
                    onChange={(e) => handleInputChange('F_ProductMaster', e.target.value)}
                  >
                    <option value="">Select</option>
                    {state.FillArray1.map((service) => (
                      <option key={service.Id} value={service.Id}>
                        {service.Name}
                      </option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
            </Row>

            <h4 className="mt-3">
              <strong>Range</strong>
            </h4>
            <Row form className="align-items-end">
              <Col md={4}>
                <FormGroup>
                  <Label for="fromInput">From</Label>
                  <Input
                    type="number"
                    id="fromInput"
                    value={state.formData.RangeFrom}
                    onChange={(e) => handleInputChange('RangeFrom', e.target.value)}
                    placeholder="Enter start range"
                  />
                </FormGroup>
              </Col>

              <Col md={4}>
                <FormGroup>
                  <Label for="toInput">To</Label>
                  <Input
                    type="number"
                    id="toInput"
                    value={state.formData.RangeTo}
                    onChange={(e) => handleInputChange('RangeTo', e.target.value)}
                    placeholder="Enter end range"
                  />
                </FormGroup>
              </Col>

              <Col md={4} className="text-center">
                <FormGroup>
                  <Label>
                    Cal Type: {state.formData.IsFlat ? 'Flat' : 'Variable'}
                  </Label>
                  <div>
                    <Toggle
                      checked={state.formData.IsFlat}
                      onChange={() =>
                        handleInputChange('IsFlat', !state.formData.IsFlat)
                      }
                      icons={{ checked: 'Flat', unchecked: '' }}
                    />
                  </div>
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col lg="4">
                <FormGroup>
                  <Label for="amountInput">Amount</Label>
                  <Input
                    type="number"
                    id="amountInput"
                    value={state.formData.Amount}
                    onChange={(e) => handleInputChange('Amount', e.target.value)}
                    placeholder="Enter Amount"
                  />
                </FormGroup>
              </Col>
            </Row>

            <div className="d-flex justify-content-between mt-4">
              <Button color="primary" type="submit">
                Add
              </Button>
              <Button color="secondary" type="button">
                Cancel
              </Button>
              {/* <Button color="success" type="button">
                Excel
              </Button> */}
            </div>
          </Form>
        </CardBody>
      </Card>

      {/* Modal for adding new plan */}
      <Modal isOpen={isModalOpen} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Add New Plan</ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label for="newPlanName">Plan Name</Label>
            <Input
              type="text"
              id="newPlanName"
              value={newPlanName}
              onChange={(e) => setNewPlanName(e.target.value)}
              placeholder="Enter plan name"
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleModalSubmit}>
            Submit
          </Button>
          <Button color="secondary" onClick={toggleModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default AddEdit_PlanAdd;
